import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";

import { closed } from "../../components/drawer/drawerSlice";
// import FormSelectionField from "../../components/formFields/FormSelectionField";
// import { STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import { clearShippingMovementsDetails } from "./shippingmovemntsSlice";
import {
  createShippingMovements,
  getAllShippingMovements,
  getShippingMovementsByID,
  updateShippingMovements,
} from "./services/shippingmovement.services";

const CreateShippingMovements: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const ShippingMovementsDetail = useAppSelector(
    (state) => state.shippingmovements.ShippingMovementsDetail
  );
  const shipping_movements_guid = useAppSelector((state) => state.drawer.data);
  const formLoading = useAppSelector(
    (state) => state.shippingmovements.formLoading
  );

  useEffect(() => {
    return () => {
      dispatch(clearShippingMovementsDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (shipping_movements_guid) {
      dispatch(getShippingMovementsByID(shipping_movements_guid));
    }
  }, [shipping_movements_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!shipping_movements_guid) {
        const insertPayload = {
          shipping_movements: values.shipping_movements,
        };
        const response = await dispatch(createShippingMovements(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearShippingMovementsDetails());
          dispatch(getAllShippingMovements());
        }
      } else {
        const editPayload = {
          shipping_movements_guid: shipping_movements_guid,
          shipping_movements: values.shipping_movements,
        };
        const response = await dispatch(updateShippingMovements(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearShippingMovementsDetails());
          dispatch(getAllShippingMovements());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ShippingMovementsDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {shipping_movements_guid
                  ? "Update ShippingMovements"
                  : "Add ShippingMovements"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="shipping_movements"
                label="Shipping Movements"
                placeholder="Shipping Movements "
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
           <ButtonWithLoading
                label={shipping_movements_guid ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
        
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
           
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateShippingMovements;
